if (!customElements.get("layout-tool")) {
  customElements.define(
    "layout-tool",
    class LayoutTool extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll(".view-button");
        this.cookieName = "product_grid_layout";

        // Set default layout to medium if no cookie exists
        if (!this.getCookie(this.cookieName)) {
          this.setCookie(this.cookieName, "medium", 365 * 10); // 10 years
        }

        // Apply saved layout on page load
        const savedLayout = this.getCookie(this.cookieName);
        this.applyLayout(savedLayout);

        // Add click handlers to buttons
        this.buttons.forEach((button) => {
          button.addEventListener("click", () => {
            const layout = button.classList.contains("small")
              ? "small"
              : button.classList.contains("medium")
              ? "medium"
              : "large";
            this.applyLayout(layout);
            this.setCookie(this.cookieName, layout, 365 * 10); // 10 years
          });
        });
      }

      applyLayout(layout) {
        // Remove all layout classes from root
        document.documentElement.classList.remove(
          "layout-small",
          "layout-medium",
          "layout-large"
        );
        // Add the new layout class to root
        document.documentElement.classList.add(`layout-${layout}`);

        // Update active state of buttons
        this.buttons.forEach((button) => {
          button.classList.remove("active");
          if (
            (layout === "small" && button.classList.contains("small")) ||
            (layout === "medium" && button.classList.contains("medium")) ||
            (layout === "large" && button.classList.contains("large"))
          ) {
            button.classList.add("active");
          }
        });
      }

      setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value};${expires};path=/`;
      }

      getCookie(name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === " ") c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length);
        }
        return null;
      }
    }
  );
}
